import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/empty.vue").then(m => m.default || m))
}